module.exports = __webpack_public_path__ + "img/layer-bg_01.9d871724.jpg";